export default {
  data() {
    return {
      inputValue: null,
      regExp: "",
    };
  },
  mounted() {
    const input = this.$children[0].$refs.input;
    if (!input) {
      return;
    }

    input.addEventListener("input", () => {
      if (!this.regExp) {
        return;
      }
      if (this.regExp.test(input.value)) {
        this.inputValue = input.value.replace(this.regExp, "");
      }
    });
  },
};
